import React, { useEffect, useState } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';

const ToolTip:React.FC<IProps> = (props) => {

  return (
    <S.Root style={props.containerStyle} >
      {props.children}
      {
        props.tip &&
        <S.TextBox style={props.boxStyle} >
          <S.TextTitle style={props.style} >
            {props.tip}
          </S.TextTitle>
        </S.TextBox>
      }
    </S.Root>
  );
}

export default ToolTip;